import { VStack } from "@chakra-ui/react"
import React from "react"
import { CreateServiceForm } from "../../forms"

export const CreateService: React.FC = () => {
	return (
		<VStack w="full" maxW="sm" spacing={6}>
			<CreateServiceForm />
		</VStack>
	)
}
